{% block jga_revocation_period_start %}
    <sw-single-select
        class="jga-revocation-period-start"
        :value="currentValue"
        :options="options"
        value-property="value"
        label-property="label"
        :label="label"
        :help-text="helpText"
        :show-clearable-button="false"
        @update:value="onChange"
    >
        <template #result-item="{ item, index, isSelected, setValue, getKey, labelProperty }">
            <li
                v-if="item.isHeader"
                class="jga-revocation-period-start__group-header"
                :class="{ 'jga-revocation-period-start__group-header--separated': item.value === '__header_delivery' }"
                role="presentation"
            >
                <span class="jga-revocation-period-start__group-header-label">{{ item.label }}</span>
                <sw-help-text
                    v-if="item.helpText"
                    :text="item.helpText"
                    :width="360"
                    class="jga-revocation-period-start__group-header-help"
                />
            </li>
            <sw-select-result
                v-else
                :selected="isSelected(item)"
                v-bind="{ item, index }"
                @item-select="setValue"
            >
                {{ getKey(item, labelProperty) }}
            </sw-select-result>
        </template>
    </sw-single-select>
{% endblock %}
